module.exports = __webpack_public_path__ + "img/right-up-arrow.29cfdbab.svg";